import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { TabView, TabPanel } from "primereact/tabview";
import { connect } from "react-redux";
import CustomBreadCrumbs from "../../common/breadcrumbs";
import MyRewards from "./MyRewards";
import PointsHistory from "./PointsHistory";
import {
  rewardsRequest,
  pointsHistoryRequest,
} from "../../../store/slices/selfSlice";
import "./learner-rewards.scss";
import { useNavigate } from "react-router-dom";

const LearnerRewards = ({
  rewards,
  pointsHistory,
  requesting,
  rewardsRequest,
  pointsHistoryRequest,
}) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    rewardsRequest();
    pointsHistoryRequest();
  }, [rewardsRequest, pointsHistoryRequest]);

  const labels = [{ label: "my_rewards" }];

  return (
    <div className="edexlms-page">
      <CustomBreadCrumbs labels={labels} navigate={navigate} />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {intl.formatMessage({ id: "rewards" })}
          </div>
        </div>
        <div className="edexlms-page-body">
          <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
            className="learner-rewards-tabs"
          >
            <TabPanel header={intl.formatMessage({ id: "my_rewards" })}>
              <MyRewards rewards={rewards} requesting={requesting} />
            </TabPanel>
            <TabPanel header={intl.formatMessage({ id: "points_history" })}>
              <PointsHistory
                pointsHistory={pointsHistory}
                requesting={requesting}
              />
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  rewards: state.self.rewards,
  pointsHistory: state.self.pointsHistory,
  requesting: state.self.requesting,
});

const mapDispatchToProps = (dispatch) => ({
  rewardsRequest: () => dispatch(rewardsRequest()),
  pointsHistoryRequest: () => dispatch(pointsHistoryRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LearnerRewards);
